module.exports = __webpack_public_path__ + "static/media/logo.b54f1d20.png";